import {
  useAccountHasPlanPaid,
  useAccountHasTrialPlanPaid
} from '../../../../../../lib/store/dashboard.store';
import { useAccountHasLillyPaid } from '../../../../../../lib/store/frame.store';
import { useNewLillyClaim } from '../../../../../../lib/store/v3/layout';
import { handleOpenEmail } from '../../../../../../utils';
import ReactHtmlParser from 'react-html-parser';
import { Userpilot } from 'userpilot';

export const UpgradePlanText = ({
  classname,
  iconSide,
  textclass,
  handleClickUpgrade,
  headerTextForNoPlan,
  isShortened,
  noRocketIcon,
  customText,
  fromConnectors,
  fontSize
}: {
  classname?: any;
  iconSide?: string;
  textclass?: string;
  handleClickUpgrade?: any;
  headerTextForNoPlan?: string;
  isShortened?: boolean;
  noRocketIcon?: boolean;
  customText?: string;
  fromConnectors?: boolean;
  fontSize?: string;
}) => {
  const accountPaid = useAccountHasPlanPaid((state: any) => state.accountPaid);
  const newLillyClaim = useNewLillyClaim((state: any) => state.newLillyClaim);
  const accountLillyPaid = useAccountHasLillyPaid((state: any) => state.accountPaid);
  const trialAccountPaid = useAccountHasTrialPlanPaid((state: any) => state.trialAccountPaid);

  const handleClickOnUpgrade = () => {
    Userpilot.track('upgrade_button');
    handleClickUpgrade();
  };

  return (
    <div className={`${classname ? classname : ''} flex items-center`}>
      {iconSide === 'left' ? (
        <img src="/icons/rocket-colorful.png" alt="Rocket" className="ml-1" />
      ) : (
        <></>
      )}

      {accountPaid || accountLillyPaid || trialAccountPaid || newLillyClaim ? (
        <>
          <span className={`${textclass ? textclass : 'text-base'} font-normal text-[#364152]`}>
            Contact us at{' '}
            <span
              className="text-[#2497B2] cursor-pointer font-semibold underline underline-offset-4"
              onClick={handleOpenEmail}>
              support@drumroll.ai
            </span>{' '}
            for extra{' '}
            {headerTextForNoPlan?.includes('columns')
              ? 'columns'
              : headerTextForNoPlan?.includes('rows')
              ? 'rows'
              : 'files'}
          </span>
        </>
      ) : (
        <>
          <span className={`${textclass ? textclass : 'text-base'} font-normal text-[#364152]`}>
            {' '}
            <span
              onClick={handleClickOnUpgrade}
              className={`${
                fontSize ? fontSize : ''
              } bg-[#FD8F220D] text-[#FD8F22] underline decoration-[#FD8F22] underline-offset-4 font-bold cursor-pointer`}>
              Upgrade
            </span>{' '}
            {!isShortened ? (
              <>
                {!fromConnectors ? (
                  <>
                    for extra{' '}
                    {headerTextForNoPlan?.includes('columns')
                      ? 'columns'
                      : headerTextForNoPlan?.includes('rows')
                      ? 'rows'
                      : 'files'}{' '}
                    and other features
                  </>
                ) : (
                  <>
                    <span className="font-semibold">to unlock this and other features</span>
                  </>
                )}
              </>
            ) : !customText || customText?.length == 0 ? (
              <span className="font-bold"> to upload the full file and other features</span>
            ) : customText && customText?.length > 0 ? (
              <>
                {' '}
                <span className=""> {ReactHtmlParser(customText)}</span>
              </>
            ) : (
              <></>
            )}
          </span>
        </>
      )}

      {(!iconSide || iconSide === 'right') && !noRocketIcon ? (
        <img src="/icons/rocket-colorful.svg" alt="Rocket" className="ml-1" />
      ) : (
        <></>
      )}
    </div>
  );
};
